import LTR from "@brand-icons/global/ui-arrow-up-solid/ui-arrow-up-solid-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiArrowUpSolidIcon = iconFactory("UiArrowUpSolidIcon", LTR);
